import React, { useState } from 'react';
import axios from 'axios';
import * as Routes from 'routes';
import { useAlerts } from 'components/Alerts';
import styled from '@emotion/styled';

const WorkItemSubscription = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
  border: 1px solid hsl(0,0%,80%);
  border-radius: 4px;

  & > span {
    padding: 0 6px 0 8px;
  }
`;

const UnsubscribeButton = styled.div`
  padding: 8px 4px;
  border-radius: 0 4px 4px 0;
  color: #a8a29e;
  line-height: 0;
  cursor: pointer;

  & > svg {
    display: inline-block;
    fill: currentColor;
    line-height: 1;
    stroke: currentColor;
    stroke-width: 0;
  }

  &:hover {
    background-color: #eee;
    color: indianred;
  }
`;

const Subscriptions = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

const WorkItems = ({ subscribedWorkItems, deletePath }) => {
  const alerts = useAlerts();

  const onUnsubscribe = React.useCallback((workItemId) => {
    const workItemPath = `${deletePath}/${workItemId}.json`;
    axios.delete(workItemPath)
      .then(() => window.location.reload())
      .catch(() => alerts.error('Could not remove this roadmap item subscription'));
  }, [deletePath]);

  return (
    <Subscriptions>
      {subscribedWorkItems.map((item) => (
        <WorkItemSubscription key={item.id}>
          <span>{item.name}</span>
          <UnsubscribeButton onClick={() => onUnsubscribe(item.id)}>
            <svg height="14" width="14" viewBox="0 0 20 20" focusable="false">
              <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
            </svg>
          </UnsubscribeButton>
        </WorkItemSubscription>
      ))}
    </Subscriptions>
  );
};

export default WorkItems;
